import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-contracts',
  templateUrl: './program-contracts.component.html',
  styleUrls: ['./program-contracts.component.scss']
})
export class ProgramContractsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
